(function () {
  'use strict';

  function initialize(root) {
    if (root.dataset.clcExtReady) return;
    var sticky = root.querySelector('#sticky');
    var offer = root.querySelector('#offer');
    if (!sticky || !offer) return;
    root.dataset.clcExtReady = 'true';

    // Preserve the source threshold and offer suppression, and give every
    // inline purchase link priority over the floating duplicate.
    var inlineCtas = Array.prototype.filter.call(root.querySelectorAll('a[data-clc-cta]'), function (anchor) {
      return !sticky.contains(anchor);
    });
    function visible(element, top, bottom) {
      var rect = element.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0 && rect.top < bottom && rect.bottom > top;
    }
    function update() {
      var y = window.scrollY;
      var height = document.body.scrollHeight;
      var viewport = window.visualViewport;
      var top = viewport ? viewport.offsetTop : 0;
      var bottom = top + (viewport ? viewport.height : window.innerHeight);
      var inlineVisible = inlineCtas.some(function (anchor) { return visible(anchor, top, bottom); });
      var show = y > height * 0.12 && !inlineVisible && !visible(offer, top, bottom) &&
        root.getBoundingClientRect().bottom > bottom;
      // Hide immediately so the exit animation cannot overlap an inline CTA.
      sticky.style.visibility = show ? '' : 'hidden';
      sticky.inert = !show;
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      sticky.classList.toggle('on', show);
    }
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    window.addEventListener('orientationchange', update);
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', update);
      window.visualViewport.addEventListener('scroll', update);
    }
    update();

    // The source carries the complete incoming query to its product links.
    var query = location.search;
    if (query) {
      root.querySelectorAll('a[data-clc-cta]').forEach(function (anchor) {
        anchor.href += (anchor.href.indexOf('?') > -1 ? '&' : '?') + query.slice(1);
      });
    }

    function unload(event) {
      if (!event.target.contains(root)) return;
      window.removeEventListener('scroll', update);
      window.removeEventListener('resize', update);
      window.removeEventListener('orientationchange', update);
      if (window.visualViewport) {
        window.visualViewport.removeEventListener('resize', update);
        window.visualViewport.removeEventListener('scroll', update);
      }
      document.removeEventListener('shopify:section:unload', unload);
    }
    document.addEventListener('shopify:section:unload', unload);
  }

  document.querySelectorAll('.clc-10-reasons-ext01').forEach(initialize);
  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('.clc-10-reasons-ext01').forEach(initialize);
  });
}());
